/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchContactCompaniesQueryResponse,
  SearchContactCompaniesQueryParams,
} from '../types/SearchContactCompanies'

function getSearchContactCompaniesUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/contacts/companies-search/` as const,
  }
  return res
}

/**
 * @summary Search the tenant's contact companies by name
 * {@link /api/v1/contacts/companies-search/}
 */
export async function searchContactCompanies(
  params: SearchContactCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchContactCompaniesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchContactCompaniesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
